/**
 * Do not edit directly
 * Generated on Fri, 21 Jun 2024 06:24:43 GMT
 */ const dtcgTokens = {
    "SwanBaseBorderRadius0": "var(--swan-base-border-radius-0)",
    "SwanBaseBorderRadius100": "var(--swan-base-border-radius-100)",
    "SwanBaseBorderRadius200": "var(--swan-base-border-radius-200)",
    "SwanBaseBorderRadius300": "var(--swan-base-border-radius-300)",
    "SwanBaseBorderRadius400": "var(--swan-base-border-radius-400)",
    "SwanBaseBorderRadiusMax": "var(--swan-base-border-radius-max)",
    "SwanBaseBorderWidth0": "var(--swan-base-border-width-0)",
    "SwanBaseBorderWidth100": "var(--swan-base-border-width-100)",
    "SwanBaseBorderWidth200": "var(--swan-base-border-width-200)",
    "SwanBaseBorderWidth300": "var(--swan-base-border-width-300)",
    "SwanBaseBreakpointXsStart": "var(--swan-base-breakpoint-xs-start)",
    "SwanBaseBreakpointXsEnd": "var(--swan-base-breakpoint-xs-end)",
    "SwanBaseBreakpointSmStart": "var(--swan-base-breakpoint-sm-start)",
    "SwanBaseBreakpointSmEnd": "var(--swan-base-breakpoint-sm-end)",
    "SwanBaseBreakpointMdStart": "var(--swan-base-breakpoint-md-start)",
    "SwanBaseBreakpointMdEnd": "var(--swan-base-breakpoint-md-end)",
    "SwanBaseBreakpointLgStart": "var(--swan-base-breakpoint-lg-start)",
    "SwanBaseBreakpointLgEnd": "var(--swan-base-breakpoint-lg-end)",
    "SwanBaseBreakpointXlStart": "var(--swan-base-breakpoint-xl-start)",
    "SwanBaseColorTransparent": "var(--swan-base-color-transparent)",
    "SwanBaseColorBlack": "var(--swan-base-color-black)",
    "SwanBaseColorBlackOpacity90": "var(--swan-base-color-black-opacity-90)",
    "SwanBaseColorBlackOpacity80": "var(--swan-base-color-black-opacity-80)",
    "SwanBaseColorBlackOpacity70": "var(--swan-base-color-black-opacity-70)",
    "SwanBaseColorBlackOpacity60": "var(--swan-base-color-black-opacity-60)",
    "SwanBaseColorBlackOpacity50": "var(--swan-base-color-black-opacity-50)",
    "SwanBaseColorBlackOpacity40": "var(--swan-base-color-black-opacity-40)",
    "SwanBaseColorBlackOpacity30": "var(--swan-base-color-black-opacity-30)",
    "SwanBaseColorBlackOpacity20": "var(--swan-base-color-black-opacity-20)",
    "SwanBaseColorBlackOpacity10": "var(--swan-base-color-black-opacity-10)",
    "SwanBaseColorGrey100": "var(--swan-base-color-grey-100)",
    "SwanBaseColorGrey200": "var(--swan-base-color-grey-200)",
    "SwanBaseColorGrey300": "var(--swan-base-color-grey-300)",
    "SwanBaseColorGrey400": "var(--swan-base-color-grey-400)",
    "SwanBaseColorGrey500": "var(--swan-base-color-grey-500)",
    "SwanBaseColorGrey600": "var(--swan-base-color-grey-600)",
    "SwanBaseColorGrey700": "var(--swan-base-color-grey-700)",
    "SwanBaseColorGrey800": "var(--swan-base-color-grey-800)",
    "SwanBaseColorGrey900": "var(--swan-base-color-grey-900)",
    "SwanBaseColorWhite": "var(--swan-base-color-white)",
    "SwanBaseColorWhiteOpacity90": "var(--swan-base-color-white-opacity-90)",
    "SwanBaseColorWhiteOpacity80": "var(--swan-base-color-white-opacity-80)",
    "SwanBaseColorWhiteOpacity70": "var(--swan-base-color-white-opacity-70)",
    "SwanBaseColorWhiteOpacity60": "var(--swan-base-color-white-opacity-60)",
    "SwanBaseColorWhiteOpacity50": "var(--swan-base-color-white-opacity-50)",
    "SwanBaseColorWhiteOpacity40": "var(--swan-base-color-white-opacity-40)",
    "SwanBaseColorWhiteOpacity30": "var(--swan-base-color-white-opacity-30)",
    "SwanBaseColorWhiteOpacity20": "var(--swan-base-color-white-opacity-20)",
    "SwanBaseColorWhiteOpacity10": "var(--swan-base-color-white-opacity-10)",
    "SwanBaseColorRed100": "var(--swan-base-color-red-100)",
    "SwanBaseColorRed400": "var(--swan-base-color-red-400)",
    "SwanBaseColorRed700": "var(--swan-base-color-red-700)",
    "SwanBaseColorYellow100": "var(--swan-base-color-yellow-100)",
    "SwanBaseColorYellow700": "var(--swan-base-color-yellow-700)",
    "SwanBaseColorYellow900": "var(--swan-base-color-yellow-900)",
    "SwanBaseColorGreen100": "var(--swan-base-color-green-100)",
    "SwanBaseColorGreen400": "var(--swan-base-color-green-400)",
    "SwanBaseColorGreen700": "var(--swan-base-color-green-700)",
    "SwanBaseColorBlue400": "var(--swan-base-color-blue-400)",
    "SwanBaseColorBlue700": "var(--swan-base-color-blue-700)",
    "SwanBaseFontFamilyPrimary": "var(--swan-base-font-family-primary)",
    "SwanBaseFontFamilySecondary": "var(--swan-base-font-family-secondary)",
    "SwanBaseFontSize100": "var(--swan-base-font-size-100)",
    "SwanBaseFontSize200": "var(--swan-base-font-size-200)",
    "SwanBaseFontSize300": "var(--swan-base-font-size-300)",
    "SwanBaseFontSize400": "var(--swan-base-font-size-400)",
    "SwanBaseFontSize500": "var(--swan-base-font-size-500)",
    "SwanBaseFontSize600": "var(--swan-base-font-size-600)",
    "SwanBaseFontSize700": "var(--swan-base-font-size-700)",
    "SwanBaseFontSize800": "var(--swan-base-font-size-800)",
    "SwanBaseFontSize900": "var(--swan-base-font-size-900)",
    "SwanBaseFontSize050": "var(--swan-base-font-size-050)",
    "SwanBaseFontSize075": "var(--swan-base-font-size-075)",
    "SwanBaseFontWeightNormal": "var(--swan-base-font-weight-normal)",
    "SwanBaseFontWeightBold": "var(--swan-base-font-weight-bold)",
    "SwanBaseFontLetterSpacing100": "var(--swan-base-font-letter-spacing-100)",
    "SwanBaseFontLetterSpacing200": "var(--swan-base-font-letter-spacing-200)",
    "SwanBaseFontLetterSpacing300": "var(--swan-base-font-letter-spacing-300)",
    "SwanBaseFontLetterSpacing025": "var(--swan-base-font-letter-spacing-025)",
    "SwanBaseFontLetterSpacing050": "var(--swan-base-font-letter-spacing-050)",
    "SwanBaseFontLetterSpacing075": "var(--swan-base-font-letter-spacing-075)",
    "SwanBaseFontLineHeight100": "var(--swan-base-font-line-height-100)",
    "SwanBaseFontLineHeight200": "var(--swan-base-font-line-height-200)",
    "SwanBaseFontLineHeight300": "var(--swan-base-font-line-height-300)",
    "SwanBaseFontLineHeight400": "var(--swan-base-font-line-height-400)",
    "SwanBaseFontLineHeight500": "var(--swan-base-font-line-height-500)",
    "SwanBaseFontLineHeight075": "var(--swan-base-font-line-height-075)",
    "SwanBaseSpace0": "var(--swan-base-space-0)",
    "SwanBaseSpace100": "var(--swan-base-space-100)",
    "SwanBaseSpace150": "var(--swan-base-space-150)",
    "SwanBaseSpace200": "var(--swan-base-space-200)",
    "SwanBaseSpace300": "var(--swan-base-space-300)",
    "SwanBaseSpace400": "var(--swan-base-space-400)",
    "SwanBaseSpace550": "var(--swan-base-space-550)",
    "SwanBaseSpace700": "var(--swan-base-space-700)",
    "SwanBaseSpace900": "var(--swan-base-space-900)",
    "SwanBaseSpace1200": "var(--swan-base-space-1200)",
    "SwanBaseSpace1600": "var(--swan-base-space-1600)",
    "SwanBaseSpace025": "var(--swan-base-space-025)",
    "SwanBaseSpace050": "var(--swan-base-space-050)",
    "SwanBaseSpace075": "var(--swan-base-space-075)",
    "SwanSemBorderRadiusNone": "var(--swan-sem-border-radius-none)",
    "SwanSemBorderRadiusSubtle": "var(--swan-sem-border-radius-subtle)",
    "SwanSemBorderRadiusStandard": "var(--swan-sem-border-radius-standard)",
    "SwanSemBorderRadiusStrong": "var(--swan-sem-border-radius-strong)",
    "SwanSemBorderRadiusRounded": "var(--swan-sem-border-radius-rounded)",
    "SwanSemBorderRadiusFocus": "var(--swan-sem-border-radius-focus)",
    "SwanSemBorderRadiusAction": "var(--swan-sem-border-radius-action)",
    "SwanSemBorderRadiusInput": "var(--swan-sem-border-radius-input)",
    "SwanSemBorderRadiusContainer": "var(--swan-sem-border-radius-container)",
    "SwanSemBorderWidthNone": "var(--swan-sem-border-width-none)",
    "SwanSemBorderWidthStandard": "var(--swan-sem-border-width-standard)",
    "SwanSemBorderWidthStrong": "var(--swan-sem-border-width-strong)",
    "SwanSemBorderWidthStronger": "var(--swan-sem-border-width-stronger)",
    "SwanSemBorderWidthInput": "var(--swan-sem-border-width-input)",
    "SwanSemBorderWidthAction": "var(--swan-sem-border-width-action)",
    "SwanSemBorderWidthPartition": "var(--swan-sem-border-width-partition)",
    "SwanSemBorderWidthFloating": "var(--swan-sem-border-width-floating)",
    "SwanSemColorBgNone": "var(--swan-sem-color-bg-none)",
    "SwanSemColorBgNoneHover": "var(--swan-sem-color-bg-none-hover)",
    "SwanSemColorBgNoneActive": "var(--swan-sem-color-bg-none-active)",
    "SwanSemColorBgStandard": "var(--swan-sem-color-bg-standard)",
    "SwanSemColorBgHover": "var(--swan-sem-color-bg-hover)",
    "SwanSemColorBgActive": "var(--swan-sem-color-bg-active)",
    "SwanSemColorBgStrong": "var(--swan-sem-color-bg-strong)",
    "SwanSemColorBgStrongHover": "var(--swan-sem-color-bg-strong-hover)",
    "SwanSemColorBgStrongActive": "var(--swan-sem-color-bg-strong-active)",
    "SwanSemColorBgDisabled": "var(--swan-sem-color-bg-disabled)",
    "SwanSemColorBgSelected": "var(--swan-sem-color-bg-selected)",
    "SwanSemColorBgSelectedHover": "var(--swan-sem-color-bg-selected-hover)",
    "SwanSemColorBgSelectedActive": "var(--swan-sem-color-bg-selected-active)",
    "SwanSemColorBgAccent": "var(--swan-sem-color-bg-accent)",
    "SwanSemColorBgError": "var(--swan-sem-color-bg-error)",
    "SwanSemColorBgWarning": "var(--swan-sem-color-bg-warning)",
    "SwanSemColorBgSuccess": "var(--swan-sem-color-bg-success)",
    "SwanSemColorBgPromo": "var(--swan-sem-color-bg-promo)",
    "SwanSemColorBgHelp": "var(--swan-sem-color-bg-help)",
    "SwanSemColorBgAction": "var(--swan-sem-color-bg-action)",
    "SwanSemColorBgActionHover": "var(--swan-sem-color-bg-action-hover)",
    "SwanSemColorBgActionActive": "var(--swan-sem-color-bg-action-active)",
    "SwanSemColorBgControl": "var(--swan-sem-color-bg-control)",
    "SwanSemColorBgControlHover": "var(--swan-sem-color-bg-control-hover)",
    "SwanSemColorBgControlActive": "var(--swan-sem-color-bg-control-active)",
    "SwanSemColorBgInput": "var(--swan-sem-color-bg-input)",
    "SwanSemColorBgContainer": "var(--swan-sem-color-bg-container)",
    "SwanSemColorBgPage": "var(--swan-sem-color-bg-page)",
    "SwanSemColorBorderNone": "var(--swan-sem-color-border-none)",
    "SwanSemColorBorderNoneHover": "var(--swan-sem-color-border-none-hover)",
    "SwanSemColorBorderNoneActive": "var(--swan-sem-color-border-none-active)",
    "SwanSemColorBorderStandard": "var(--swan-sem-color-border-standard)",
    "SwanSemColorBorderHover": "var(--swan-sem-color-border-hover)",
    "SwanSemColorBorderActive": "var(--swan-sem-color-border-active)",
    "SwanSemColorBorderStrong": "var(--swan-sem-color-border-strong)",
    "SwanSemColorBorderStrongHover": "var(--swan-sem-color-border-strong-hover)",
    "SwanSemColorBorderStrongActive": "var(--swan-sem-color-border-strong-active)",
    "SwanSemColorBorderDisabled": "var(--swan-sem-color-border-disabled)",
    "SwanSemColorBorderSelected": "var(--swan-sem-color-border-selected)",
    "SwanSemColorBorderSelectedHover": "var(--swan-sem-color-border-selected-hover)",
    "SwanSemColorBorderSelectedActive": "var(--swan-sem-color-border-selected-active)",
    "SwanSemColorBorderAccent": "var(--swan-sem-color-border-accent)",
    "SwanSemColorBorderError": "var(--swan-sem-color-border-error)",
    "SwanSemColorBorderWarning": "var(--swan-sem-color-border-warning)",
    "SwanSemColorBorderSuccess": "var(--swan-sem-color-border-success)",
    "SwanSemColorBorderPromo": "var(--swan-sem-color-border-promo)",
    "SwanSemColorBorderHelp": "var(--swan-sem-color-border-help)",
    "SwanSemColorBorderAction": "var(--swan-sem-color-border-action)",
    "SwanSemColorBorderActionHover": "var(--swan-sem-color-border-action-hover)",
    "SwanSemColorBorderActionActive": "var(--swan-sem-color-border-action-active)",
    "SwanSemColorBorderControl": "var(--swan-sem-color-border-control)",
    "SwanSemColorBorderControlHover": "var(--swan-sem-color-border-control-hover)",
    "SwanSemColorBorderControlActive": "var(--swan-sem-color-border-control-active)",
    "SwanSemColorBorderInput": "var(--swan-sem-color-border-input)",
    "SwanSemColorBorderInputHover": "var(--swan-sem-color-border-input-hover)",
    "SwanSemColorBorderInputActive": "var(--swan-sem-color-border-input-active)",
    "SwanSemColorBorderContainer": "var(--swan-sem-color-border-container)",
    "SwanSemColorBorderPartition": "var(--swan-sem-color-border-partition)",
    "SwanSemColorTextStandard": "var(--swan-sem-color-text-standard)",
    "SwanSemColorTextSubtle": "var(--swan-sem-color-text-subtle)",
    "SwanSemColorTextInput": "var(--swan-sem-color-text-input)",
    "SwanSemColorTextPlaceholder": "var(--swan-sem-color-text-placeholder)",
    "SwanSemColorTextError": "var(--swan-sem-color-text-error)",
    "SwanSemColorTextWarning": "var(--swan-sem-color-text-warning)",
    "SwanSemColorTextDisabled": "var(--swan-sem-color-text-disabled)",
    "SwanSemColorTextPromo": "var(--swan-sem-color-text-promo)",
    "SwanSemColorTextHover": "var(--swan-sem-color-text-hover)",
    "SwanSemColorTextActive": "var(--swan-sem-color-text-active)",
    "SwanSemColorTextAccent": "var(--swan-sem-color-text-accent)",
    "SwanSemColorTextHelp": "var(--swan-sem-color-text-help)",
    "SwanSemColorTextSuccess": "var(--swan-sem-color-text-success)",
    "SwanSemElevationNone": "var(--swan-sem-elevation-none)",
    "SwanSemElevationSubtle": "var(--swan-sem-elevation-subtle)",
    "SwanSemElevationStandard": "var(--swan-sem-elevation-standard)",
    "SwanSemElevationStrong": "var(--swan-sem-elevation-strong)",
    "SwanSemElevationFloating": "var(--swan-sem-elevation-floating)",
    "SwanSemElevationOverlay": "var(--swan-sem-elevation-overlay)",
    "SwanSemElevationScrollHorizontal": "var(--swan-sem-elevation-scroll-horizontal)",
    "SwanSemFocusColorInner": "var(--swan-sem-focus-color-inner)",
    "SwanSemFocusColorOuter": "var(--swan-sem-focus-color-outer)",
    "SwanSemFocusStandard": "var(--swan-sem-focus-standard)",
    "SwanSemFocusInset": "var(--swan-sem-focus-inset)",
    "SwanSemFocusTight": "var(--swan-sem-focus-tight)",
    "SwanSemFontSizeX4large": "var(--swan-sem-font-size-x4large)",
    "SwanSemFontSizeX3large": "var(--swan-sem-font-size-x3large)",
    "SwanSemFontSizeX2large": "var(--swan-sem-font-size-x2large)",
    "SwanSemFontSizeXlarge": "var(--swan-sem-font-size-xlarge)",
    "SwanSemFontSizeLarge": "var(--swan-sem-font-size-large)",
    "SwanSemFontSizeStandard": "var(--swan-sem-font-size-standard)",
    "SwanSemFontSizeSmall": "var(--swan-sem-font-size-small)",
    "SwanSemFontSizeXsmall": "var(--swan-sem-font-size-xsmall)",
    "SwanSemMqEqXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqEqLg": "'only screen and (min-width: 1440px) and (max-width: 1919px)'",
    "SwanSemMqEqMd": "'only screen and (min-width: 1024px) and (max-width: 1439px)'",
    "SwanSemMqEqSm": "'only screen and (min-width: 768px) and (max-width: 1023px)'",
    "SwanSemMqEqXs": "'only screen and (max-width: 767px)'",
    "SwanSemMqGtXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtLg": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtMd": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGtSm": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGtXs": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGteLg": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGteMd": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGteSm": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXs": "'only screen and (min-width: 0px)'",
    "SwanSemMqLtXl": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLtLg": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLtMd": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLtSm": "'only screen and (max-width: 767px)'",
    "SwanSemMqLtXs": "'only screen and (max-width: 0px)'",
    "SwanSemMqLteXl": "'only screen'",
    "SwanSemMqLteLg": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLteMd": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLteSm": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLteXs": "'only screen and (max-width: 767px)'",
    "SwanSemSpace1": "var(--swan-sem-space-1)",
    "SwanSemSpace2": "var(--swan-sem-space-2)",
    "SwanSemSpace3": "var(--swan-sem-space-3)",
    "SwanSemSpace4": "var(--swan-sem-space-4)",
    "SwanSemSpace5": "var(--swan-sem-space-5)",
    "SwanSemSpace6": "var(--swan-sem-space-6)",
    "SwanSemSpace7": "var(--swan-sem-space-7)",
    "SwanSemSpace8": "var(--swan-sem-space-8)",
    "SwanSemSpace9": "var(--swan-sem-space-9)",
    "SwanSemSpace10": "var(--swan-sem-space-10)",
    "SwanSemSpace11": "var(--swan-sem-space-11)",
    "SwanSemSpace12": "var(--swan-sem-space-12)",
    "SwanSemSpaceNone": "var(--swan-sem-space-none)",
    "SwanSemZIndexRaised": "var(--swan-sem-z-index-raised)",
    "SwanSemZIndexLinkCovering": "var(--swan-sem-z-index-link-covering)",
    "SwanSemZIndexOverlay": "var(--swan-sem-z-index-overlay)",
    "SwanSemZIndexFloating": "var(--swan-sem-z-index-floating)",
    "SwanSemZIndexOverTheTop": "var(--swan-sem-z-index-over-the-top)",
    "SwanCompAccordionPaddingStandard": "var(--swan-comp-accordion-padding-standard)",
    "SwanCompAccordionPaddingVertical": "var(--swan-comp-accordion-padding-vertical)",
    "SwanCompAccordionPaddingRightInteger": "var(--swan-comp-accordion-padding-right-integer)",
    "SwanCompAlertBoxColorBg": "var(--swan-comp-alert-box-color-bg)",
    "SwanCompAlertBoxColorTextInverse": "var(--swan-comp-alert-box-color-text-inverse)",
    "SwanCompAlertBoxLegalColorBg": "var(--swan-comp-alert-box-legal-color-bg)",
    "SwanCompAlertBoxLegalColorText": "var(--swan-comp-alert-box-legal-color-text)",
    "SwanCompAlertBoxWarningColorText": "var(--swan-comp-alert-box-warning-color-text)",
    "SwanCompAnchorBarListScrollBarColorBorder": "var(--swan-comp-anchor-bar-list-scroll-bar-color-border)",
    "SwanCompAnchorBarSizeMinHeight": "var(--swan-comp-anchor-bar-size-min-height)",
    "SwanCompAnchorBarListItemBlock": "var(--swan-comp-anchor-bar-list-item-block)",
    "SwanCompAvatarInnerStroke": "var(--swan-comp-avatar-inner-stroke)",
    "SwanCompBannerColorBg": "var(--swan-comp-banner-color-bg)",
    "SwanCompBannerLeftHandNavigationColorBg": "var(--swan-comp-banner-left-hand-navigation-color-bg)",
    "SwanCompBannerLeftHandNavigationColorText": "var(--swan-comp-banner-left-hand-navigation-color-text)",
    "SwanCompBannerLeftHandNavigationDividerColorBorder": "var(--swan-comp-banner-left-hand-navigation-divider-color-border)",
    "SwanCompBannerLeftHandNavigationFocus": "var(--swan-comp-banner-left-hand-navigation-focus)",
    "SwanCompBannerTextContainerColorBg": "var(--swan-comp-banner-text-container-color-bg)",
    "SwanCompBannerInner": "var(--swan-comp-banner-inner)",
    "SwanCompBannerActionSizeMinHeight": "var(--swan-comp-banner-action-size-min-height)",
    "SwanCompBannerImageContainerSizeMaxHeight": "var(--swan-comp-banner-image-container-size-max-height)",
    "SwanCompBannerSizeMaxWidth": "var(--swan-comp-banner-size-max-width)",
    "SwanCompBannerSizeMinHeightStandard": "var(--swan-comp-banner-size-min-height-standard)",
    "SwanCompBannerSizeMinHeightShort": "var(--swan-comp-banner-size-min-height-short)",
    "SwanCompBannerGridGutterStandard": "var(--swan-comp-banner-grid-gutter-standard)",
    "SwanCompBannerBoundedContentInnerHorizontal": "var(--swan-comp-banner-bounded-content-inner-horizontal)",
    "SwanCompBannerBoundedContentInner": "var(--swan-comp-banner-bounded-content-inner)",
    "SwanCompBannerTextOffset": "var(--swan-comp-banner-text-offset)",
    "SwanCompBoundedContentSizeMaxWidth": "var(--swan-comp-bounded-content-size-max-width)",
    "SwanCompBoundedContentGridGutterStandard": "var(--swan-comp-bounded-content-grid-gutter-standard)",
    "SwanCompBoundedContentInnerHorizontal": "var(--swan-comp-bounded-content-inner-horizontal)",
    "SwanCompBoundedContentInner": "var(--swan-comp-bounded-content-inner)",
    "SwanCompButtonPrimaryColorBg": "var(--swan-comp-button-primary-color-bg)",
    "SwanCompButtonPrimaryColorBgHover": "var(--swan-comp-button-primary-color-bg-hover)",
    "SwanCompButtonPrimaryColorBgActive": "var(--swan-comp-button-primary-color-bg-active)",
    "SwanCompButtonPrimaryColorBorder": "var(--swan-comp-button-primary-color-border)",
    "SwanCompButtonPrimaryColorBorderHover": "var(--swan-comp-button-primary-color-border-hover)",
    "SwanCompButtonPrimaryColorBorderActive": "var(--swan-comp-button-primary-color-border-active)",
    "SwanCompButtonPrimaryColorText": "var(--swan-comp-button-primary-color-text)",
    "SwanCompButtonClearSelectionColorBgActive": "var(--swan-comp-button-clear-selection-color-bg-active)",
    "SwanCompButtonClearSelectionSizeHeight": "var(--swan-comp-button-clear-selection-size-height)",
    "SwanCompButtonSizeMinHeightStandard": "var(--swan-comp-button-size-min-height-standard)",
    "SwanCompButtonSizeMinHeightMini": "var(--swan-comp-button-size-min-height-mini)",
    "SwanCompButtonbarColorBg": "var(--swan-comp-buttonbar-color-bg)",
    "SwanCompButtonbarButtonHeight": "var(--swan-comp-buttonbar-button-height)",
    "SwanCompCalloutColorBgInverse": "var(--swan-comp-callout-color-bg-inverse)",
    "SwanCompCalloutColorBorderInverse": "var(--swan-comp-callout-color-border-inverse)",
    "SwanCompCalloutColorTextInverse": "var(--swan-comp-callout-color-text-inverse)",
    "SwanCompCalloutFoilColorText": "var(--swan-comp-callout-foil-color-text)",
    "SwanCompCalloutOverlayColorBg": "var(--swan-comp-callout-overlay-color-bg)",
    "SwanCompCalloutOverlayColorText": "var(--swan-comp-callout-overlay-color-text)",
    "SwanCompCarouselButtonColorBg": "var(--swan-comp-carousel-button-color-bg)",
    "SwanCompCarouselButtonColorBgDisabled": "var(--swan-comp-carousel-button-color-bg-disabled)",
    "SwanCompCarouselButtonColorBorderDisabled": "var(--swan-comp-carousel-button-color-border-disabled)",
    "SwanCompCarouselButtonOffsetPromoBar": "var(--swan-comp-carousel-button-offset-promo-bar)",
    "SwanCompCarouselDotsColorBg": "var(--swan-comp-carousel-dots-color-bg)",
    "SwanCompCarouselDotsColorBgHover": "var(--swan-comp-carousel-dots-color-bg-hover)",
    "SwanCompCarouselDotsColorBgInset": "var(--swan-comp-carousel-dots-color-bg-inset)",
    "SwanCompCarouselDotWidth": "var(--swan-comp-carousel-dot-width)",
    "SwanCompCarouselArrowSize": "var(--swan-comp-carousel-arrow-size)",
    "SwanCompCarouselGridGutterStandard": "var(--swan-comp-carousel-grid-gutter-standard)",
    "SwanCompCarouselGridGutterTight": "var(--swan-comp-carousel-grid-gutter-tight)",
    "SwanCompCarouselBoundedContentInnerHorizontal": "var(--swan-comp-carousel-bounded-content-inner-horizontal)",
    "SwanCompCarouselBoundedContentInner": "var(--swan-comp-carousel-bounded-content-inner)",
    "SwanCompColorSwatchesCrossbarColorBg": "var(--swan-comp-color-swatches-crossbar-color-bg)",
    "SwanCompColorSwatchesTooltipColorBg": "var(--swan-comp-color-swatches-tooltip-color-bg)",
    "SwanCompColorSwatchesTooltipColorText": "var(--swan-comp-color-swatches-tooltip-color-text)",
    "SwanCompColorSwatchesSelectedGutterStandard": "var(--swan-comp-color-swatches-selected-gutter-standard)",
    "SwanCompColorSwatchesSelectedGutterSuper": "var(--swan-comp-color-swatches-selected-gutter-super)",
    "SwanCompColorSwatchesSizeStandard": "var(--swan-comp-color-swatches-size-standard)",
    "SwanCompColorSwatchesSizeSuper": "var(--swan-comp-color-swatches-size-super)",
    "SwanCompColorSwatchesBorderWidth": "var(--swan-comp-color-swatches-border-width)",
    "SwanCompCountAlertColorBg": "var(--swan-comp-count-alert-color-bg)",
    "SwanCompCountAlertColorTextAlert": "var(--swan-comp-count-alert-color-text-alert)",
    "SwanCompDropdownSizeMinHeightStandard": "var(--swan-comp-dropdown-size-min-height-standard)",
    "SwanCompDropdownSizeMinHeightMini": "var(--swan-comp-dropdown-size-min-height-mini)",
    "SwanCompGridGutterStandard": "var(--swan-comp-grid-gutter-standard)",
    "SwanCompGridGutterTight": "var(--swan-comp-grid-gutter-tight)",
    "SwanCompListboxColorBgSelected": "var(--swan-comp-listbox-color-bg-selected)",
    "SwanCompListboxSizeMinHeightStandard": "var(--swan-comp-listbox-size-min-height-standard)",
    "SwanCompListboxSizeMinHeightMini": "var(--swan-comp-listbox-size-min-height-mini)",
    "SwanCompModalDialogBackdropColorBg": "var(--swan-comp-modal-dialog-backdrop-color-bg)",
    "SwanCompModalDialogPanelFooterElevation": "var(--swan-comp-modal-dialog-panel-footer-elevation)",
    "SwanCompModalDialogInnerSpace": "var(--swan-comp-modal-dialog-inner-space)",
    "SwanCompModalDialogPanelInnerSpace": "var(--swan-comp-modal-dialog-panel-inner-space)",
    "SwanCompModalDialogPanelButtonsBlockMenu": "var(--swan-comp-modal-dialog-panel-buttons-block-menu)",
    "SwanCompModalDialogPanelSizeWidthCapped": "var(--swan-comp-modal-dialog-panel-size-width-capped)",
    "SwanCompModalDialogPanelSizeMaxWidthMenu": "var(--swan-comp-modal-dialog-panel-size-max-width-menu)",
    "SwanCompModalDialogCloseButtonSize": "var(--swan-comp-modal-dialog-close-button-size)",
    "SwanCompModalDialogCloseButtonTop": "var(--swan-comp-modal-dialog-close-button-top)",
    "SwanCompModalDialogGridGutterStandard": "var(--swan-comp-modal-dialog-grid-gutter-standard)",
    "SwanCompModalDialogInnerHorizontal": "var(--swan-comp-modal-dialog-inner-horizontal)",
    "SwanCompModalDialogSizeHeight": "var(--swan-comp-modal-dialog-size-height)",
    "SwanCompModalDialogSizeMinHeight": "var(--swan-comp-modal-dialog-size-min-height)",
    "SwanCompModalDialogSizeMaxHeight": "var(--swan-comp-modal-dialog-size-max-height)",
    "SwanCompModalDialogSizeWidth": "var(--swan-comp-modal-dialog-size-width)",
    "SwanCompModalDialogSizeMinWidth": "var(--swan-comp-modal-dialog-size-min-width)",
    "SwanCompModalDialogSizeMaxWidth": "var(--swan-comp-modal-dialog-size-max-width)",
    "SwanCompModalDialogSizeMaxWidthGrow": "var(--swan-comp-modal-dialog-size-max-width-grow)",
    "SwanCompModalDialogSizeHeaderMaxWidth": "var(--swan-comp-modal-dialog-size-header-max-width)",
    "SwanCompProgressBarEmptyColorBg": "var(--swan-comp-progress-bar-empty-color-bg)",
    "SwanCompProgressBarFilledColorBg": "var(--swan-comp-progress-bar-filled-color-bg)",
    "SwanCompRadioButtonInnerColorBgDisabled": "var(--swan-comp-radio-button-inner-color-bg-disabled)",
    "SwanCompRangeEmptyColorBg": "var(--swan-comp-range-empty-color-bg)",
    "SwanCompSearchInputClearColorBg": "var(--swan-comp-search-input-clear-color-bg)",
    "SwanCompSelectionSetColorBorder": "var(--swan-comp-selection-set-color-border)",
    "SwanCompSelectionSetColorBorderHover": "var(--swan-comp-selection-set-color-border-hover)",
    "SwanCompSelectionSetColorBorderActive": "var(--swan-comp-selection-set-color-border-active)",
    "SwanCompSelectionSetButtonsHeight": "var(--swan-comp-selection-set-buttons-height)",
    "SwanCompSelectionSetTilesHeightStandard": "var(--swan-comp-selection-set-tiles-height-standard)",
    "SwanCompSelectionSetTilesWidthStandard": "var(--swan-comp-selection-set-tiles-width-standard)",
    "SwanCompSelectionSetTilesWidthVertical": "var(--swan-comp-selection-set-tiles-width-vertical)",
    "SwanCompSelectionSetTilesImageWidthStandard": "var(--swan-comp-selection-set-tiles-image-width-standard)",
    "SwanCompSelectionSetTilesImageWidthMini": "var(--swan-comp-selection-set-tiles-image-width-mini)",
    "SwanCompSelectionSetTilesImageHeightStandard": "var(--swan-comp-selection-set-tiles-image-height-standard)",
    "SwanCompSelectionSetTilesImageHeightVertical": "var(--swan-comp-selection-set-tiles-image-height-vertical)",
    "SwanCompSpinnerSizeAnimationTiny": "var(--swan-comp-spinner-size-animation-tiny)",
    "SwanCompSpinnerSizeAnimationMini": "var(--swan-comp-spinner-size-animation-mini)",
    "SwanCompSpinnerSizeAnimationStandard": "var(--swan-comp-spinner-size-animation-standard)",
    "SwanCompSpinnerSizeAnimationSuper": "var(--swan-comp-spinner-size-animation-super)",
    "SwanCompStandardTileGridGutterStandard": "var(--swan-comp-standard-tile-grid-gutter-standard)",
    "SwanCompStandardTileGridGutterTight": "var(--swan-comp-standard-tile-grid-gutter-tight)",
    "SwanCompStandardTileBlock": "var(--swan-comp-standard-tile-block)",
    "SwanCompStandardTileBlockEnd": "var(--swan-comp-standard-tile-block-end)",
    "SwanCompStandardTileNameBlock": "var(--swan-comp-standard-tile-name-block)",
    "SwanCompStandardTileNameBlockEnd": "var(--swan-comp-standard-tile-name-block-end)",
    "SwanCompStandardTileSizeHeight": "var(--swan-comp-standard-tile-size-height)",
    "SwanCompTextInputSizeMinHeightStandard": "var(--swan-comp-text-input-size-min-height-standard)",
    "SwanCompTextInputSizeMinHeightMini": "var(--swan-comp-text-input-size-min-height-mini)",
    "SwanCompThumbnailsHeroContentContainerMaxWidth": "var(--swan-comp-thumbnails-hero-content-container-max-width)",
    "SwanCompToggleSwitchColorBgSelected": "var(--swan-comp-toggle-switch-color-bg-selected)",
    "SwanCompToggleSwitchColorBgDisabled": "var(--swan-comp-toggle-switch-color-bg-disabled)",
    "SwanCompToggleSwitchHandleColorBg": "var(--swan-comp-toggle-switch-handle-color-bg)",
    "SwanCompToggleSwitchTrackColorBg": "var(--swan-comp-toggle-switch-track-color-bg)",
    "SwanCompToggleSwitchSizeMiniWidth": "var(--swan-comp-toggle-switch-size-mini-width)",
    "SwanCompToggleSwitchSizeMiniHeight": "var(--swan-comp-toggle-switch-size-mini-height)",
    "SwanCompToggleSwitchSizeStandardWidth": "var(--swan-comp-toggle-switch-size-standard-width)",
    "SwanCompToggleSwitchSizeStandardHeight": "var(--swan-comp-toggle-switch-size-standard-height)",
    "SwanCompToggleSwitchSizeSuperWidth": "var(--swan-comp-toggle-switch-size-super-width)",
    "SwanCompToggleSwitchSizeSuperHeight": "var(--swan-comp-toggle-switch-size-super-height)"
};

export { dtcgTokens };
